import { keepPreviousData, useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { candidatesQueryKeys } from "./query-keys";
import { GetCandidatesResponse } from "./types";

import { instance } from "@/lib/axios/instance";

export type UseCandidatesParams = {
  clients?: string[];
  integrations?: string[];
  matchIds?: string[];
  candidateIds?: string[];
  publicationIds?: string[];
  sortDirection?: string;
  sortColumn?: string;
  page?: number;
  pageSize?: number;
  search?: string;
  tenantId?: string | null;
  startDate?: string | null;
  endDate?: string | null;
};

export function useCandidates(
  params: UseCandidatesParams,
): UseQueryResult<GetCandidatesResponse, AxiosError> {
  return useQuery({
    queryKey: candidatesQueryKeys.list(params),
    queryFn: () =>
      instance
        .get<GetCandidatesResponse>("/api/v2/Candidates", { params })
        .then((res) => res.data),
    refetchOnReconnect: false,
    staleTime: 5 * 60 * 1000,
    placeholderData: keepPreviousData,
  });
}
